<ng-container *ngIf="showForm && (currentMode === Mode.Edit || currentMode === Mode.Create)">
    <div class="row">
      <div class="col-12">
        <app-profile-edit 
          [isCreatingNew]="currentMode === Mode.Create" 
          (goBack)="onGoBack()" 
          (publishProfile)="currentMode === Mode.Create ? submitNewArticle() : submitUpdatedArticle()"
          (previewProfile)="onPreviewArticle()"
          (deleteProfile)="selectedNews && selectedNews.id ? onDeleteNews(selectedNews) : null" 
          [backButtonLabel]="'label.go_back_button'"
          [previewButtonLabel]="'label.preview_button'" 
          [publishButtonLabel]="'label.publish_button'"
          [isPublishDisabled]="isPublishDisabled"
          [isPreviewDisabled]="isPreviewDisabled">
        </app-profile-edit>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8 mb-3">
        <app-case-form-section-container [iconClass]="'bi bi-text-left'" [title]="'label.write_article'">
          <app-write-article-form [form]="form" [isViewMode]="false"></app-write-article-form>
        </app-case-form-section-container>
      </div>

      <div class="col-12 col-md-4 mb-3">
        <app-case-form-section-container [iconClass]="'bi bi-link-45deg'" [title]="'label.related_news'" [rightIconClass]="'bi bi-plus-circle'" [iconDisabled]="relatedNewsEdit" (onClickRightIcon)="addRelatedNewsRow()">
          <app-related-news 
            [relatedNews]="relatedNews"
            [form]="form"
            [newsItems]="news"
            [isViewMode]="false"
            [addNewsRow]="addRelatedNews"
            (addRelatedNews)="onAddRelatedNews($event)"
            (deleteRelatedNews)="onDeleteRelatedNews($event)"
            (viewRelatedNews)="onViewRelatedNews($event)"
            (selectRelatedNews)="relatedNewsEdit = false">
          </app-related-news>
        </app-case-form-section-container>
      </div>
    </div>
</ng-container>


<ng-container *ngIf="(currentMode === Mode.View) && selectedNews">
  <div class="d-flex justify-content-start mb-3">
    <app-back-navigation [backTitle]="'buttons.back'" [action]="'buttons.delete'" [actionIconClass]="'bi bi-trash-fill'" (onClickBack)="onGoBack()" (onClickAction)="onDeleteNews(selectedNews)"></app-back-navigation>
  </div>

  <div class="col-12 mb-3">
    <app-news-view-header 
      [title]="selectedNews.title" 
      [author]="selectedNews.autorName" 
      [date]="selectedNews.publishDate"
      [authorIconClass]="'bi bi-person-circle'"
    ></app-news-view-header>
  </div>

  <div class="row view-article-related">
    <div class="col-12" [ngClass]="{'col-md-8': relatedNews && relatedNews.length}">
      <app-write-article-form [form]="form" [isViewMode]="true"></app-write-article-form>
    </div>
    @if(relatedNews && relatedNews.length) {
      <div class="col-12 col-md-4">
        <app-related-news [relatedNews]="relatedNews" [form]="form" [isViewMode]="true"></app-related-news>
      </div>
    }

  </div>
</ng-container>

<ng-container *ngIf="currentMode === Mode.Preview && selectedNews">

  <app-back-navigation [backTitle]="'buttons.back'" [action]="selectedNews.id ? 'buttons.delete' : ''" [actionIconClass]="'bi bi-trash-fill'" (onClickBack)="onBackFromPreview()" (onClickAction)="onDeleteNews(selectedNews)"></app-back-navigation>

  <div class="col-12 mb-3">
    <app-news-view-header 
      [title]="selectedNews.title" 
      [author]="selectedNews.autorName" 
      [date]="selectedNews.publishDate"
      [authorIconClass]="'bi bi-person-circle'"
    ></app-news-view-header>
  </div>

  <div class="row view-article-related">
    <div class="col-12" [ngClass]="{ 'col-md-8' : relatedNews && relatedNews.length }">
      <app-write-article-form [form]="form" [isViewMode]="true"></app-write-article-form>
    </div>
    @if(relatedNews && relatedNews.length) {
      <div class="col-12 col-md-4">
        <app-related-news [relatedNews]="relatedNews" [form]="form" [isViewMode]="true"></app-related-news>
      </div>
    }
  </div>
</ng-container>


<app-case-form-section-container *ngIf="!showForm && currentMode === null"  [iconClass]="'bi bi-newspaper'" [title]="'label.news'" 
  [showButton]="true" [buttonLabel]="'label.new_article'" [buttonIconClass]="'bi bi-plus'" (onButtonClick)="onCreateNews()">
  <div *ngIf="news.length > 0" class="news-list">
    <div class="col-12">
      <div *ngFor="let newsItem of news" class="news-item-container mb-3">
        <app-news-preview [newsItem]="newsItem" [showMenu]="true" (onEdit)="onEditNews(newsItem)" (onView)="onViewNews(newsItem)" (onDelete)="onDeleteNews(newsItem)">
        </app-news-preview>
      </div>
    </div>
  </div>
</app-case-form-section-container>

<app-pagination *ngIf="!selectedNews && !showForm && currentMode === null" [currentPage]="currentPage" [totalItems]="totalNewsCount"
  [itemsPerPage]="selectedPageSize" [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageSelect($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)">
</app-pagination>